export class EmailValidator {
  private regex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  validate(value: string): boolean {
    return (value && value !== '-') ? this.regex.test(value) : true
  }

  errorMessage(): string {
    return 'It should be a valid email.'
  }
}